import { render, staticRenderFns } from "./SubmitTags.vue?vue&type=template&id=1ffc1d89&"
import script from "./SubmitTags.vue?vue&type=script&lang=js&"
export * from "./SubmitTags.vue?vue&type=script&lang=js&"
import style0 from "./SubmitTags.vue?vue&type=style&index=0&id=1ffc1d89&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports